<div class="workSpace" style="background-color: transparent;">
  @switch (typeFilter) {
  @case (Filters.PERIOD) {
  <table class="w3-table" style="height: 6.5vh; width: 100% !important; table-layout: fixed;">
    <tr>
      <!-- Define que la mitad del contenedor sera para el nombre -->
      <td style="width: 50%;">
        <!-- Botón que nos ayudara expandir el menu -->
        <button class="w3-button w3-right" [matMenuTriggerFor]="menuAnios">
          {{name}}
          <!-- Icono del menu -->
          <mat-icon class="iconoMen">expand_more</mat-icon>
        </button>
        <!-- Menu desplegable -->
        <mat-menu class="w3-medium" #menuAnios="matMenu">
          @for (anio of array; track $index) {
          @if (anio.visible) {
          <!-- Botón del segundo menu -->
          <button mat-menu-item [matMenuTriggerFor]="menuMeses">
            <span style="padding-left: 10px;"> {{anio.anio}}</span>
          </button>
          <!-- Menu desplegable -->
          <mat-menu class="w3-medium" #menuMeses="matMenu">
            @for (mes of anio.series; track $index) {
            @if (mes.visible) {
            <!-- Opciones del menu -->
            <button mat-menu-item (click)="$event.stopPropagation(); selectInformation(mes);">
              <!-- Menu desplegable -->
              <div class="w3-quarter" style="padding-top: 3px;">
                <!-- Input que nos genera el checkbox -->
                <input type="checkbox" style="cursor: pointer;" [id]="'check_'+mes.mes+''+mes.anio"
                  [checked]="mes.check">
              </div>
              <!-- Texto de la opción -->
              <div class="w3-rest" style="padding-left: 10px;">{{'filtros.'+mes.mes|translate}}</div>
            </button>
            }
            }
          </mat-menu>
          }
          }
        </mat-menu>
      </td>
      <!-- Parte izquierda del menú que nos representa los chips -->
      <td style="width: 50% !important; overflow: hidden; vertical-align: middle;">
        <!-- Contenedor del chip el que determina el espacio a ocupar de los chips -->
        <div class="containerChip">
          <!-- Ajusta el tamaño del chip y que esten en una sola linea -->
          <div #chipsViewport class="chipsViewport">
            <!-- Ciclo o ciclos que nos da los chips -->
            <!-- @for (anio of array; track $index) { -->
            @for (mes of visibleChips; track $index) {
            <!-- Contiene el div que determina que chip se ve y cual no y da el formato final del chip -->
            <div #chipItem (click)="selectInformation(mes, 'chip')" [ngClass]="{
                      'w3-center w3-elemento-menu':mes.check,
                      'w3-hide':!mes.check}" class="filtroChipSelect">
              {{'filtros.'+mes.mes|translate}} {{mes.anio}}
              <!-- Determina cuando aparece lo de cerrar el chip -->
              @if (click) {
              <span class="iconoChip">X</span>
              }
            </div>
            }
            <!-- } -->
          </div>
          @if(hiddenCount > 0){
          <!-- Genera los tres puntos si hay mas de una selección -->
          <div class="tresPuntos">
            <!-- Icono que despliega todas las selecciones -->
            <mat-icon [ngStyle]="{'color':'gray'}" class="iconoClosed w3-button"
              [matMenuTriggerFor]="menuDesplegable">more_horiz</mat-icon>
            <!-- Menu de las selecciones -->
            <mat-menu #menuDesplegable="matMenu" xPosition="before">
              <!-- Zona del chip -->
              <div class="chip" style="margin-left: 1vw;">
                @for (anio of array; track $index) {
                @for (mes of anio.series; track $index) {
                <!-- Formato final del chip al igual que si se muestra o no -->
                <div (click)="selectInformation(mes, 'chip')" [ngClass]="{
                            'w3-center w3-elemento-menu':mes.check,
                            'w3-hide':!mes.check}" class="filtroChipSelect">
                  {{'filtros.'+mes.mes|translate}} {{mes.anio}}
                  @if (click) {
                  <span class="iconoChip">X</span>
                  }
                </div>
                }
                }
              </div>
            </mat-menu>
          </div>
          }
        </div>
      </td>
    </tr>
  </table>
  }
  @case (Filters.MOUNTH) {
  <table class="w3-table" style="height: 6.5vh;">
    <tr>
      <!-- Define que la mitad del contenedor sera para el nombre -->
      <td style="width: 50%;">
        <!-- Botón que nos ayudara expandir el menu -->
        <button class="w3-button w3-right" [matMenuTriggerFor]="menuAnios">
          {{name}}
          <!-- Icono del menu -->
          <mat-icon class="iconoMen">expand_more</mat-icon>
        </button>
        <!-- Menu desplegable -->
        <mat-menu class="w3-medium" #menuAnios="matMenu">
          @for (mes of array; track $index) {
          <!-- Opciones del menu -->
          <button mat-menu-item (click)="$event.stopPropagation(); selectInformation(mes);">
            <!-- Menu desplegable -->
            <div class="w3-quarter" style="padding-top: 3px;">
              <!-- Input que nos genera el checkbox -->
              <input type="checkbox" style="cursor: pointer;" [id]="''+mes.name" [checked]="mes.check">
            </div>
            <!-- Texto de la opción -->
            <div class="w3-rest" style="padding-left: 10px;">{{mes.name}}</div>
          </button>
          }
        </mat-menu>
      </td>
      <!-- Parte izquierda del menú que nos representa los chips -->
      <td>
        <!-- Contenedor del chip el que determina el espacio a ocupar de los chips -->
        <div class="containerChip">
          <!-- Ajusta el tamaño del chip y que esten en una sola linea -->
          <div class="chip adjust">
            <!-- Ciclo o ciclos que nos da los chips -->
            @for (mes of array; track $index) {
            <!-- Contiene el div que determina que chip se ve y cual no y da el formato final del chip -->
            <div (click)="selectInformation(mes, 'chip')" [ngClass]="{
                      'w3-center w3-elemento-menu':mes.check,
                      'w3-hide':!mes.check}" class="filtroChipSelect">
              {{mes.name}}
              <!-- Determina cuando aparece lo de cerrar el chip -->
              @if (click) {
              <span class="iconoChip">X</span>
              }
            </div>
            }
          </div>
        </div>
      </td>
    </tr>
  </table>
  }
  @case (Filters.YEAR) {
  <table class="w3-table" style="height: 6.5vh;">
    <tr>
      <td>
        <!-- Botón que nos ayudara expandir el menu -->
        <button class="w3-button w3-right" [matMenuTriggerFor]="menuAnios">
          {{name}}
          <!-- Icono del menu -->
          <mat-icon class="iconoMen">expand_more</mat-icon>
        </button>
        <!-- Menu desplegable -->
        <mat-menu class="w3-medium" #menuAnios="matMenu">
          @for (anio of array; track $index) {
          <!-- Opciones del menu -->
          <button mat-menu-item (click)="$event.stopPropagation(); selectInformation(anio);">
            <!-- Menu desplegable -->
            <div class="w3-quarter" style="padding-top: 3px;">
              <!-- Input que nos genera el checkbox -->
              <input type="checkbox" style="cursor: pointer;" [id]="''+anio.anio" [checked]="anio.check">
            </div>
            <!-- Texto de la opción -->
            <div class="w3-rest" style="padding-left: 10px;">{{anio.name}}</div>
          </button>
          }
        </mat-menu>
      </td>
      <td>
        <div class="containerChip">
          <!-- Ajusta el tamaño del chip y que esten en una sola linea -->
          <div class="chip adjust">
            <!-- Ciclo o ciclos que nos da los chips -->
            @for (anio of array; track $index) {
            <!-- Contiene el div que determina que chip se ve y cual no y da el formato final del chip -->
            <div (click)="selectInformation(anio, 'chip')" [ngClass]="{
                    'w3-center w3-elemento-menu':anio.check,
                    'w3-hide':!anio.check}" class="filtroChipSelect">
              {{anio.name}}
              <!-- Determina cuando aparece lo de cerrar el chip -->
              @if (click) {
              <span class="iconoChip">X</span>
              }
            </div>
            }
          </div>
        </div>
      </td>
    </tr>
  </table>
  }
  @case (Filters.PERSPECTIVES) {
  <table class="w3-table" style="height: 6.5vh;">
    <tr>
      <td style="width: 50%;">
        <!-- Botón que nos ayudara expandir el menu -->
        <button class="w3-button w3-right" [matMenuTriggerFor]="analisis">
          {{name}}
          <!-- Icono del menu -->
          <mat-icon class="iconoMen">expand_more</mat-icon>
        </button>
        <mat-menu class="w3-medium" style="width: fit-content;" #analisis="matMenu">
          @for (pers of array; track $index) {
          <button mat-menu-item (click)="$event.stopPropagation(); selectInformation(pers);"
            style="display: flex; align-items: center; width: 100%;">
            <div style="margin-right: 8px; float: left; padding-top: 3px;">
              <input type="checkbox" style="cursor: pointer;" [checked]="pers.check">
            </div>
            <div style="flex: 1; min-width: 0; float: left;">
              <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{pers.name}}</span>
            </div>
          </button>
          }
        </mat-menu>
      </td>
      <td>
        <!-- Contenedor del chip el que determina el espacio a ocupar de los chips -->
        <div class="containerChip">
          <!-- Ajusta el tamaño del chip y que esten en una sola linea -->
          <div class="chip adjust">
            <!-- Ciclo o ciclos que nos da los chips -->
            @for (pers of array; track $index) {
            <!-- Formato final del chip al igual que si se muestra o no -->
            <div (click)="selectInformation(pers, 'chip')" [ngClass]="{
                    'w3-center w3-elemento-menu':pers.check,
                    'w3-hide':!pers.check}" class="filtroChipSelect">
              {{pers.name}}
              @if (click) {
              <span class="iconoChip">X</span>
              }
            </div>
            }
          </div>
        </div>
      </td>
    </tr>
  </table>
  }
  @case (Filters.SUCURSALES) {
  <table class="w3-table" style="height: 6.5vh;">
    <tr>
      <td style="width: 50%;">
        <!-- Botón que expande el menú -->
        <button class="w3-button w3-right" [matMenuTriggerFor]="menuOpcionesSucursales">
          {{name}}
          <mat-icon class="iconoMen">expand_more</mat-icon>
        </button>

        <!-- Menú desplegable -->
        <mat-menu class="w3-medium filtroMenuAncho" style="width: fit-content;" #menuOpcionesSucursales="matMenu">
          <button mat-menu-item (click)="$event.stopPropagation(); selectInformation('consolidado');"
            style="display: flex; align-items: center; width: 100%;">
            <div style="margin-right: 8px; float: left; padding-top: 3px;">
              <input type="checkbox" style="cursor: pointer;" [checked]="consolidado">
            </div>
            <div style="flex: 1; min-width: 0; float: left;">
              <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{'filtros.consolidado' |
                translate}}</span>
            </div>
          </button>
          <mat-divider></mat-divider>
          <!-- <button mat-menu-item [matMenuTriggerFor]="menuSucursales"
            style="display: flex; align-items: center; width: 100%;">

            <div style="flex: 1; min-width: 0; float: left;">
              <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{'filtros.consolidado' |
                translate}}</span>
            </div>
          </button> -->
          <!-- <mat-menu class="w3-medium" style="width: fit-content;" #menuSucursales="matMenu"> -->
            @if (!consolidado) {
              @for (suc of array; track $index) {
                <!-- Opciones del menu -->
                <button mat-menu-item (click)="$event.stopPropagation(); selectInformation(suc);"
                  style="display: flex; align-items: center; width: 100%;">
                  <div style="margin-right: 8px; float: left; padding-top: 3px;">
                    <input type="checkbox" style="cursor: pointer;" [checked]="suc.check">
                  </div>
                  <div style="flex: 1; min-width: 0; float: left;">
                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{suc.name}}</span>
                  </div>
                </button>
              }
            }
          <!-- </mat-menu> -->

        </mat-menu>
      </td>

      <!-- Chips dinámicos -->
      <td>
        <div class="containerChip">
          <!-- Ajusta el tamaño del chip y que esten en una sola linea -->
          <div class="chip adjust">
            <!-- Ciclo o ciclos que nos da los chips -->
            @if(consolidado) {
              <div class="w3-center w3-elemento-menu filtroChipSelect">
                {{'filtros.consolidado' | translate}}
              </div>
            } @else {
              @for (suc of array; track $index) {
                <div [ngClass]="{
                          'w3-center w3-elemento-menu':suc.check,
                          'w3-hide':!suc.check}" class="filtroChipSelect">
                  {{suc.name}}
                </div>
              }
            }
          </div>
        </div>
      </td>
    </tr>
  </table>
  }
  @case (Filters.ESCENARIOS) {
    <table class="w3-table" style="height: 6.5vh;">
      <tr>
        <td style="white-space: nowrap;">
          <button class="w3-button w3-right" [matMenuTriggerFor]="menuEscenarios">
            {{name}}
            <mat-icon class="iconoMen">expand_more</mat-icon>
          </button>
          <mat-menu [class]="panelAncho ? 'w3-medium filtroMenuAncho' : 'w3-medium'" #menuEscenarios="matMenu">
            @for (esc of array; track $index) {
            <button mat-menu-item [disabled]="esc.disabled" (click)="$event.stopPropagation(); selectInformation(esc);" style="display: flex; align-items: center; width: 100%;">
              <div style="margin-right: 8px; float: left; padding-top: 3px;">
                <input type="checkbox" style="cursor: pointer;" [checked]="esc.check">
              </div>
              <div style="flex: 1; max-width: 200px; float: left; overflow: hidden; text-overflow: ellipsis;" [matTooltip]="esc.name" [appOverflowTooltip]="esc.name">
                <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{esc.name}}</span>
              </div>
            </button>
            }
          </mat-menu>
        </td>
        <td>
          <div class="containerChip">
            <div class="chip adjust">
              @if(!consolidado) {
                @for (esc of array; track $index) {
                  <div [ngClass]="{
                            'w3-center w3-elemento-menu':esc.check,
                            'w3-hide':!esc.check}" class="filtroChipSelect" [matTooltip]="esc.name">
                    <span class="textoChip">{{esc.name}}</span>
                  </div>
                }
              } @else {
                <div class="w3-center w3-elemento-menu filtroChipSelect">
                  {{ name }}
                </div>
              }
            </div>
          </div>
        </td>
      </tr>
    </table>
  }
  @case (Filters.BUSQUEDA) {
    <table class="w3-table" style="height: 6.5vh;">
      <tr>
        <td style="width: 50%;">
          <button class="w3-button w3-right" [matMenuTriggerFor]="menuBusqueda">
            {{name}}
            <mat-icon class="iconoMen">expand_more</mat-icon>
          </button>
          <mat-menu class="w3-medium" #menuBusqueda="matMenu">
             <!-- Campo de búsqueda -->
            <div class="menu-search">
              <input
                matInput
                placeholder="Buscar ..."
                (keydown)="$event.stopImmediatePropagation()"
                (click)="$event.stopPropagation()"
                (keyup)="filterOpt($event)"
              />
            </div>

            <!-- Opciones filtradas -->
            @for (esc of array; track $index) {
            <button mat-menu-item class="textoOverFlow" (click)="$event.stopPropagation(); selectInformation(esc);">
              <!-- <div class="textoOverFlow borderTest"> -->
                {{esc.name}}
              <!-- </div> -->
            </button>
            }
          </mat-menu>
        </td>
        <td>
          <div class="containerChip">
            <div class="chip adjust">
              @if(!consolidado) {
                @for (esc of array; track $index) {
                  <div [ngClass]="{
                            'w3-center w3-elemento-menu':esc.check,
                            'w3-hide':!esc.check}" class="filtroChipSelect">
                    {{esc.name}}
                  </div>
                }
              } @else {
                <div class="w3-center w3-elemento-menu filtroChipSelect">
                  {{ name }}
                </div>
              }
            </div>
          </div>
        </td>
      </tr>
    </table>
  }
  @case (Filters.INDICADORES) {
    <table class="w3-table" style="height: 6.5vh;">
      <tr>
        <td style="width: 50%;">
          <button class="w3-button w3-right" [matMenuTriggerFor]="menuBusqueda">
            {{name}}
            <mat-icon class="iconoMen">expand_more</mat-icon>
          </button>
          <mat-menu class="w3-medium" #menuBusqueda="matMenu">
            <!-- Opciones -->
            @for (ind of array; track $index) {
            <button mat-menu-item class="textoOverFlow" (click)="$event.stopPropagation(); selectInformation(ind);">
              <!-- <div class="textoOverFlow borderTest"> -->
                {{ind.name}}
              <!-- </div> -->
            </button>
            }
          </mat-menu>
        </td>
        <td>
          <div class="containerChip">
            <div class="chip adjust">
              @if(!consolidado) {
                @for (esc of array; track $index) {
                  <div [ngClass]="{
                            'w3-center w3-elemento-menu':esc.check,
                            'w3-hide':!esc.check}" class="filtroChipSelect">
                    {{esc.name}}
                  </div>
                }
              } @else {
                <div class="w3-center w3-elemento-menu filtroChipSelect">
                  {{ name }}
                </div>
              }
            </div>
          </div>
        </td>
      </tr>
    </table>
  }

}
</div>